import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { DELIVERY_TYPE_META, typeMeta } from './opsTypes';
import { DeliveryCalendar } from '../shared/calendar/DeliveryCalendar';

const DONE = ['completed', 'delivered', 'cancelled', 'canceled'];
const titleCase = (s) => (s || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// All-up calendar of every delivery type, colour-coded by type.
export const OpsCalendar = ({ events = [] }) => {
  const navigate = useNavigate();
  const [hiddenTypes, setHiddenTypes] = useState(() => new Set());

  const toggleType = (t) => setHiddenTypes((prev) => {
    const next = new Set(prev);
    if (next.has(t)) next.delete(t); else next.add(t);
    return next;
  });

  const calEvents = useMemo(() => events.filter((e) => !hiddenTypes.has(e.type)).map((e) => ({
    id: `${e.type}-${e.session_id || e.id}`,
    title: e.title,
    start: e.start,
    end: e.end,
    startTime: e.start_time,
    endTime: e.end_time,
    color: typeMeta(e.type).color,
    muted: DONE.includes(e.status),
    statusLabel: `${typeMeta(e.type).label} · ${titleCase(e.status) || '—'}`,
    trainers: e.trainers || [],
    pm: e.pm_name,
    client: e.partner_name,
    onClick: () => navigate(e.url),
  })), [events, hiddenTypes, navigate]);

  const typeToggles = (
    <div className="flex flex-wrap items-center gap-2" data-testid="calendar-type-filters">
      {Object.entries(DELIVERY_TYPE_META).map(([k, m]) => {
        const off = hiddenTypes.has(k);
        return (
          <button key={k} type="button" onClick={() => toggleType(k)}
            className={`flex items-center gap-1.5 text-xs px-2 py-1 rounded-full border transition-opacity ${off ? 'opacity-40 border-dashed' : 'border-transparent'}`}
            style={{ background: off ? 'transparent' : `${m.color}14` }}
            title={off ? `Show ${m.label}` : `Hide ${m.label}`}
            data-testid={`calendar-filter-${k}`}>
            <span className="w-2.5 h-2.5 rounded-full" style={{ background: m.color }} />
            <span className={off ? 'line-through text-muted-foreground' : 'text-foreground'}>{m.label}</span>
          </button>
        );
      })}
    </div>
  );

  return <DeliveryCalendar events={calEvents} toolbarExtra={typeToggles} testId="ops-calendar" />;
};

export default OpsCalendar;
